import I18n from 'I18n';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import debounce from 'react-utils/debounce';
import { useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_DEBOUNCE_TIME = 800;
const DebouncedSearchInputFilter = ({
  onChange,
  placeholder = I18n.text('learningCenter.myTeam.filters.search.placeholder'),
  value,
  debounceTime = DEFAULT_DEBOUNCE_TIME
}) => {
  const [localValue, setLocalValue] = useState(value);

  // Sync local state when store value changes
  // eslint-disable-next-line react-hooks/set-state-in-render
  useMemo(() => setLocalValue(value), [value]);

  // Memoize the debounced handler to prevent recreation on every render
  const debouncedChangeHandler = useMemo(() => debounce(newValue => onChange(newValue), debounceTime), [onChange, debounceTime]);

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      debouncedChangeHandler.reset();
    };
  }, [debouncedChangeHandler]);
  const handleChange = event => {
    const newValue = event.target.value;
    setLocalValue(newValue);
    if (newValue === '') {
      onChange(''); // immediate update for clearing
      debouncedChangeHandler.reset(); // cancel any pending debounced calls
    } else {
      debouncedChangeHandler(newValue);
    }
  };
  return /*#__PURE__*/_jsx(SearchInput, {
    onChange: handleChange,
    placeholder: placeholder,
    value: localValue
  });
};
export default DebouncedSearchInputFilter;